import { render, staticRenderFns } from "./CircleLoader.vue?vue&type=template&id=62fe3b40&scoped=true"
var script = {}
import style0 from "./CircleLoader.vue?vue&type=style&index=0&id=62fe3b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fe3b40",
  null
  
)

export default component.exports